import { render, staticRenderFns } from "./ClinicsServices.vue?vue&type=template&id=a0dea806&"
import script from "./ClinicsServices.vue?vue&type=script&lang=js&"
export * from "./ClinicsServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports